import FeedbackApi from '../logic/FeedbackApi'
import {Box, TextField} from '@mui/material'
import Button from '@mui/material/Button'
import React, {useState} from 'react'
import LoadingBackdrop from '../components/LoadingBackdrop'
import ApiException from '../model/ApiException'
import MuiLink from '@mui/material/Link'
import {Link} from 'react-router-dom'

const api = new FeedbackApi()

export default function Feedback() {
  const [loading, setLoading] = useState<boolean>(false)
  const [feedback, setFeedback] = useState<string>('')
  const [feedbackError, setFeedbackError] = useState<string>('')
  const [done, setDone] = useState<boolean>(false)

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    if (loading) return

    setLoading(true)

    try {
      const res = await api.submit(feedback)

      if (!res.isError()) {
        setDone(true)
        return
      }

      const ex = res.exception as ApiException

      if (!!ex.errors['Feedback']) {
        setFeedbackError(ex.errors['Feedback'][0])
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {!done && <Box component="form">
        <LoadingBackdrop loading={loading}/>

        <h1>Feedback</h1>

        <p>Help us make it better by leaving some feedback!</p>

        <p>If you found a bug, please include what you were doing when it happened and what device and browser you were using. If you have some ideas for new
          features or to improve existing ones, we'd love to hear from you!</p>

        <TextField
          multiline
          fullWidth
          label="Feedback"
          rows="4"
          value={feedback}
          onChange={(e) => {
            setFeedbackError('')
            setFeedback(e.target.value)
          }}
          error={!!feedbackError}
          helperText={feedbackError}
        />

        <Button
          onClick={handleSubmit}
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: 3,
            mb: 2,
            fontWeight: 900,
          }}
        >
          Submit Feedback
        </Button>
      </Box>}
      {done && <Box>
        <p>Thanks for submitting feedback! <MuiLink to="/" component={Link} style={{textDecoration: "none"}}>Go back</MuiLink></p>
      </Box>}
    </>
  )
}
